import { render, staticRenderFns } from "./insurances.vue?vue&type=template&id=6b97a7ee&"
import script from "./insurances.vue?vue&type=script&lang=js&"
export * from "./insurances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports